import { render, staticRenderFns } from "./ViewOtherServicesDrawer.vue?vue&type=template&id=18805dd0&scoped=true&"
import script from "./ViewOtherServicesDrawer.vue?vue&type=script&lang=js&"
export * from "./ViewOtherServicesDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ViewOtherServicesDrawer.vue?vue&type=style&index=0&id=18805dd0&lang=scss&scoped=true&"
import style1 from "./ViewOtherServicesDrawer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18805dd0",
  null
  
)

export default component.exports